export const HINT_INFO = {
  ORDER_INTRO: {
    title: 'Реестр',
    description:
      'В этом разделе содержатся все доступные из 1С EРП согласованные заказы и поставки.',
  },
  ISSUE_HYBRID_INTRO: {
    title: 'Детали поставки',
    description:
      'На данной странице загружается список всех реализаций по выбранному заказу. Для создания финансового требования выберите реализации.',
  },
  SPECIFICATION_INTRO: {
    title: 'Финансовое требование',
    description:
      'На данной странице созданное вами финансовое требование, для выставления которого необходимо все проверить и подписать УКЭП.',
  },
};
